import { useMemo } from 'react';

import { mapAccountDetails } from '@/api/account/account-details';
import { useSettings } from '@/hooks/state/useSettings';

/**
 * The signed-in user's account summary, derived from settings (the bootstrap
 * response). Refresh it by invalidating settings.
 */
export const useAccountDetails = () => {
  const { settings, isLoading } = useSettings();

  const data = useMemo(
    () =>
      settings?.user?.is_authenticated
        ? mapAccountDetails(settings)
        : undefined,
    [settings]
  );

  return { data, isLoading };
};
